// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — option-receipt.classic.js, новая — option-receipt.cp.js
import { isCp } from 'libs/design';
import * as classic from './option-receipt.classic';
import * as cp from './option-receipt.cp';

export const OptionReceipt = isCp ? cp.OptionReceipt : classic.OptionReceipt;
